import { Link } from "react-router-dom";
const Register = () => {
    return (
        <section className="section-auth">
      <div className="auth-card">
        <div className="auth-card-body">
          <span className="auth-card-title">Register a new membership</span>
          <form>
             <div className="form-group input-icon">
              <input
                type="text"
                className="form-control"
                placeholder="Full Name"
              />
              <i className="fas fa-user" />
            </div>
            <div className="form-group input-icon">
              <input
                type="email"
                className="form-control"
                placeholder="Email"
              />
              <i className="fas fa-envelope" />
            </div>
            <div className="form-group input-icon">
              <input
                type="password"
                className="form-control"
                placeholder="Password"
              />
              <i className="fas fa-lock" />
            </div>
            <div className="form-group input-icon">
              <input
                type="password"
                className="form-control"
                placeholder="Retype Password"
              />
              <i className="fas fa-right-to-bracket" />
            </div>
            <div className="flex-space-between">
              <Link to="/">I already have a membership</Link>
              <button type="submit"  className="my-button">
                Register
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
    );
}
export default Register;